module.exports = __webpack_public_path__ + "img/3.e89d2469.jpeg";